import PropTypes from 'prop-types';
import { formatReportingPeriodDateRange } from '../../utils/executive-pulse-reporting-period.js';

const HUB_LABELS = {
    ok: { text: 'Hub connected', tone: 'ok' },
    partial: { text: 'Hub degraded', tone: 'partial' },
    error: { text: 'Hub not connected', tone: 'error' }
};

function hubSummary(hub) {
    if (!hub || hub.status === 'disabled' || hub.enabled === false) {
        return null;
    }
    if (typeof hub.status !== 'string') {
        return { text: 'Hub status unknown', tone: 'unknown' };
    }
    return (
        HUB_LABELS[hub.status] ?? {
            text: `Hub: ${hub.status}`,
            tone: 'unknown'
        }
    );
}

export default function DashboardHeader({ hub, reportingPeriod, children }) {
    const hubPill = hubSummary(hub);
    const tooltip =
        hubPill &&
        (hub?.detail ||
            (hub?.hubUsedForKpis?.length
                ? `Live metrics: ${hub.hubUsedForKpis.join(', ')}`
                : undefined));

    const periodLabel = reportingPeriod?.label;
    const periodRange = formatReportingPeriodDateRange(reportingPeriod);
    const subtitle = periodRange || periodLabel || 'Executive KPI overview';

    return (
        <header className="header">
            <div className="header-top">
                <div className="header-left">
                    <h1>Executive Pulse</h1>
                    <p>{subtitle}</p>
                </div>
                {hubPill ? (
                    <span
                        className={`hub-pill hub-pill--${hubPill.tone}`}
                        title={tooltip || undefined}>
                        {hubPill.text}
                    </span>
                ) : null}
            </div>
            {children ? (
                <div className="header-controls">{children}</div>
            ) : null}
        </header>
    );
}

DashboardHeader.propTypes = {
    hub: PropTypes.shape({
        status: PropTypes.string,
        enabled: PropTypes.bool,
        detail: PropTypes.string,
        hubUsedForKpis: PropTypes.arrayOf(PropTypes.string)
    }),
    reportingPeriod: PropTypes.shape({
        label: PropTypes.string,
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        chartEndDate: PropTypes.string,
        isFutureQuarter: PropTypes.bool
    }),
    children: PropTypes.node
};

DashboardHeader.defaultProps = {
    hub: undefined,
    reportingPeriod: undefined,
    children: undefined
};
